import { useEffect, useState } from 'react'
import {
  Show,
  Create,
  SimpleForm,
  FormDataConsumer,
  required,
  SelectInput,
  ReferenceInput,
  useGetOne,
  useNotify,
  useRedirect,
  TextInput,
  TextField,
  DateField,
  List,
  Datagrid,
  NumberField,
} from 'react-admin'
import { makeStyles } from '@material-ui/core/styles'
import { DynamicInputComponentSelf } from './tickets_common'
import { CreateToolbar } from './utils'
import Grid from '@material-ui/core/Grid'
import { parse } from 'query-string'
import Typography from '@material-ui/core/Typography'
import Alert from './components/alert'

export const PostCreateComponent = (props) => {
  return (
    <div style={{ padding: '16px 0' }}>
      <Grid container spacing={2} justify="center">
        <Grid item xs={11} md={6}>
          <Alert>
            <Typography>
              Merci ! Votre demande a été enregistrée sous le numéro :{' '}
              {props.id}
            </Typography>
            <Typography>
              Elle va être confirmée par notre équipe Support (c&apos;est
              important, notamment pour ne pas lancer plusieurs interventions
              pour un même incident). A bientôt ! 👋
            </Typography>
          </Alert>
        </Grid>
      </Grid>
    </div>
  )
}

export const ExtranetCoproTicketsList = (props) => {
  const params = parse(props.location.search)

  const code_split = params.code.split('_')
  const copro_id = code_split[0]
  const coproprietaire_id = code_split[1]

  const setWindowContext = () => {
    window.context['context-extcoproticket-coproid'] = copro_id
    window.context['context-extcoproticket-coproprietaireid'] =
      coproprietaire_id
  }
  useEffect(() => {
    setWindowContext()
  }, [copro_id, coproprietaire_id])

  return (
    <List {...props} bulkActionButtons={false} exporter={false}>
      <Datagrid rowClick={false}>
        <NumberField source="id" label="Id" />
        <TextField source="libelle" label="Nom" />
        <TextField source="step_name" label="Statut de la demande" />
        <DateField source="created" label="Créé le" />
      </Datagrid>
    </List>
  )
}
